import React from "react";
import PropTypes from "prop-types";
import { backgroundTypeProp, imageProp, videoProp } from "core-web/utils/proptypes/modules/mediaProps";
import BackgroundImage from "core-web/components/BackgroundImage";
import BackgroundVideo from "core-web/components/base/video/BackgroundVideo";
import BackgroundColor from "theme/components/BackgroundColor";

// Set a image, video or color as a background
const BackgroundSwitch = ({ children, background, type, mediaQuery, loading }) => {
    let BackgroundComponent;
    switch (type) {
        case "image":
            BackgroundComponent = (props) =>
                // Fallback to grey background if image is selected but url is missing
                background?.url ? (
                    <BackgroundImage
                        src={background.url}
                        position={background.backgroundPosition}
                        size={background.backgroundSize}
                        query={mediaQuery || background.mediaQuery}
                        loading={loading}
                        {...props}
                    />
                ) : (
                    <BackgroundColor color="grey" {...props} />
                );
            break;

        case "video":
            BackgroundComponent = (props) =>
                // Fallback to grey background if video is selected but url is missing
                background?.url ? (
                    <BackgroundVideo
                        src={background.url}
                        poster={background.poster}
                        query={background.mediaQuery}
                        loading={loading}
                        {...props}
                    />
                ) : (
                    <BackgroundColor color="grey" {...props} />
                );
            break;

        case "color":
            BackgroundComponent = (props) => <BackgroundColor color={background} {...props} />;
            break;

        default:
            BackgroundComponent = (props) => <div {...props} />;
            console.warn(`Background type ${type} not found.`);
            break;
    }

    return <BackgroundComponent>{children}</BackgroundComponent>;
};

BackgroundSwitch.propTypes = {
    background: PropTypes.oneOfType([imageProp, PropTypes.string, videoProp]).isRequired,
    children: PropTypes.node,
    loading: PropTypes.string,
    mediaQuery: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    type: backgroundTypeProp,
};

BackgroundSwitch.defaultProps = {
    children: undefined,
    loading: "lazy",
    mediaQuery: undefined,
    type: undefined,
};

export default BackgroundSwitch;
